import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useState } from 'react';
import TravelDetailsModal, { getParsedOfferDescription } from './TravelDetailsModal';
import { Quotation, TravelDay } from '../../@types/contractors';
import { formatDate } from '../../utils/date-format-handler';
import CancelIcon from '@mui/icons-material/Cancel';
import { Help } from '@mui/icons-material';

interface PriceOffersProps {
    quotations: Quotation[];
}

export default function PriceOffers({ quotations }: PriceOffersProps) {
    const [selectedQuotation, setSelectedQuotation] = useState<Quotation | null>(null);
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;

    return (
        <Box>
            <Typography variant='h4' ml={1} mt={2} mb={2}>
                Árajánlatok
            </Typography>
            <Box px={2}>
                <TableContainer>
                    <Table
                        sx={{
                            width: '100%',
                            '& .MuiTableBody-root .MuiTableCell-root': {
                                py: 1.5,
                            },
                            '& .MuiTableHead-root .MuiTableCell-root': {
                                py: 1,
                                fontWeight: 400,
                            },
                        }}
                        aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Ügymenet szám</TableCell>
                                <TableCell align='right'>Összeg</TableCell>
                                <TableCell align='center'>Megjegyzés</TableCell>
                                <TableCell align='right'>Ajánlatadás időpontja</TableCell>
                                <TableCell align='right'>Indulás időpontja</TableCell>
                                <TableCell align='center'>Részletek</TableCell>
                                <TableCell align='right'>Eredmény</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {quotations.length ? (
                                quotations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((quotation, index) => (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={index}>
                                        <TableCell component='th' scope='row'>
                                            {quotation.OfferID}
                                        </TableCell>
                                        <TableCell align='right'>{new Intl.NumberFormat('hu-HU').format(quotation.Price)} Ft</TableCell>
                                        <TableCell
                                            align='left'
                                            sx={{
                                                maxWidth: '100px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}>
                                            {quotation.Details?.Comment ? (
                                                <Tooltip title={quotation.Details.Comment}>
                                                    <Typography>{quotation.Details.Comment}</Typography>
                                                </Tooltip>
                                            ) : null}
                                        </TableCell>
                                        <TableCell align='right'>{formatDate(quotation.CreatedAt)}</TableCell>
                                        <TableCell align='right'>{formatDate((getParsedOfferDescription(quotation)?.days[0] as TravelDay)?.departure ?? '')}</TableCell>
                                        <TableCell align='center'>
                                            <Button
                                                size='small'
                                                onClick={() => {
                                                    setSelectedQuotation(quotation);
                                                }}>
                                                részletek
                                            </Button>
                                        </TableCell>

                                        <TableCell align='center'>
                                            {quotation.QuotationRequestContractor?.Accepted &&
                                            quotation.QuotationRequestContractor.AcceptedQuotationId === quotation.ID ? (
                                                <CheckCircleIcon color={'primary'} />
                                            ) : quotation.QuotationRequestContractor?.Accepted === false ||
                                              (quotation.QuotationRequestContractor?.Accepted &&
                                                  quotation.QuotationRequestContractor.AcceptedQuotationId !== quotation.ID) ? (
                                                <CancelIcon color={'error'} />
                                            ) : (
                                                <Help color={'info'} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component='th' scope='row' align={'center'} colSpan={6}>
                                        <Typography variant='h6' p={5}>
                                            Nincs megjeleníthető adat
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <TablePagination
                component='div'
                count={quotations.length}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[10]}
                sx={{ mb: 12 }}
            />
            <TravelDetailsModal open={selectedQuotation !== null} onClose={() => setSelectedQuotation(null)} quotation={selectedQuotation} />
        </Box>
    );
}
